import { IdmClientContext } from "@sista/idm-client";
import { buildSpravaTextuClient } from "@sista/library-stasi";
import { useContext, useMemo } from "react";
export const useSpravaTextuClient = () => {
    const c = useContext(IdmClientContext);
    if (c == null) {
        throw new Error("SpravaTextuClientContext is null");
    }
    const authKeyToUse = c?.loggedAccount?.authKey;
    return useMemo(() => buildSpravaTextuClient(process.env.REACT_APP_SPRAVA_TEXTU_ROOT, authKeyToUse), [authKeyToUse]);
};
